<script>
	import { onMount } from 'svelte';

    export let classe = '';
    export let title;
    export let name; 
    export let type = 'text';
    export let required = '';
    export let rows = 4;
    export let showLabel = true;
    export let defaultValue = '';
    export let selectValues = '';
    export let maxFileCount = 1;
    export let minFileCount = 0;
    export let allowedFileTypes = ['pdf'];

	let generateGUID = function() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) { var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8); return v.toString(16); });
	}
	let setMultiFileUploadNew = function(input, minFileCount, maxFileCount, allowedFileExtensions, data, settings){
		if (data == undefined || data == null) {
			data = {};
		}
		
		if (settings == undefined || settings == null) {
			settings = {};
		}

		let guid = generateGUID();

		data.mode		= 'upload';
		data.action		= 'upload';
		data.guid		= EncodeBase64(guid);

		settings = jQuery.extend({}, {
			language				: 'pt-BR',
			theme					: 'explorer',
			showUploadedThumbs 		: true,
			showPreview 			: true,
			dropZoneEnabled			: false,
			showClose				: false,
			validateInitialCount	: true,
			overwriteInitial		: false,
			showUpload				: false,
			showRemove				: false,
			showCaption				: true,
			minFileCount			: minFileCount,
			maxFileCount			: maxFileCount,
			maxTotalFileCount		: maxFileCount,
			uploadAsync				: true,
			uploadUrl				: `${document.location.origin}/Services/Mail/Send.aspx`,
			fileActionSettings 		: { 
				showZoom: false,	
				showDrag: false	
			},
			uploadExtraData			: function() {
				return data;
			}
		}, settings);
		
		if (allowedFileExtensions != undefined && allowedFileExtensions != null) {
			settings.allowedFileExtensions = allowedFileExtensions;
		}
				
		jQuery(input).attr('data-guid', guid);
		jQuery(input + 'Name').val('');
		jQuery(input + 'Guid').val(guid);
		
		
		//Cria input
		jQuery(input).fileinput('destroy');
		jQuery(input).off();
		jQuery(input).fileinput(settings);
			
		//Depois de selecionar
		jQuery(input).on('filebatchselected', function(event) {			
			
			let errorBox	= jQuery('.file-error-message li', jQuery(input).parent().parent().parent().parent());
			let errorMsg	= '';
			if (errorBox != undefined && errorBox != null) {
				errorMsg = errorBox.html();
			}
			
			if (errorMsg != undefined && errorMsg.length > 0) {
				
			} else {
				window.setTimeout(function(){
					jQuery(input).fileinput('upload');
				}, 200);
			}
		});
		//Atualiza 1 por 1
		jQuery(input).on('fileuploaded', function(event, data, previewId, index) {
			if (data.files != undefined && data.files != null && data.files.length == index + 1) {
				jQuery(input + 'Guid').val(guid);
			}		
		});

		jQuery(input).on('filesuccessremove', async function(event, id) {
			let fileName = id.split("_").slice(1,id.split("_").length).join("_");

			const parameters = {
				'mode': 'remove', 
				'action':'remove', 
				'img': EncodeBase64(fileName), 
				'guid': EncodeBase64(jQuery(input+'Guid').val())
			}

			let url = `${document.location.origin}/Services/Mail/Send.aspx?callback=null&${Object.entries(parameters).map(e=>`${e[0]}=${e[1]}`).join('&')}`;

			let response = await fetch(url,{
				method: 'GET',
				mode: 'cors'
			});

			Promise.resolve(await response.json());

		});
	};

    switch (name) {
        case 'nome':
            if (defaultValue === '' && window.store.get('field.nome') != null) {
                defaultValue = window.store.get('field.nome');
            }
            break;    
        case 'telefone':
            if (defaultValue === '' && window.store.get('field.telefone') != null) {
                defaultValue = window.store.get('field.telefone');
            }
            break;    
        case 'email':
            if (defaultValue === '' && window.store.get('field.email') != null) {
                defaultValue = window.store.get('field.email');
            }
            break;
    }

	onMount(async () => {
		switch (type) {
			case 'fileinput':
				setMultiFileUploadNew('#' + name, minFileCount, maxFileCount, allowedFileTypes, {}, {});
				break;
			default:
				break;
    	}
	});
</script>

{#if showLabel == true}
    {#if type === 'select'}
        <div class="form-group">
            <label for="{name}">{title}</label>
            <select class="form-control" id="{name}" name="{name}">
                {#each selectValues as v}
                    <option value="{v.value}">{v.title}</option>
                {/each}
            </select>
        </div>
    {:else if type === 'textarea'}
        <div class="form-group">
            <label for="{name}">{title}</label>
            <textarea {required} class="form-control {classe}" id="{name}" name="{name}" rows={rows}>{defaultValue}</textarea>
        </div>
		{:else if type === 'fileinput'}
		<div class="form-group form-upload file-input-full">
			<label for="{name}">{title}:</label>
			<input id="{name}" type="file" multiple />
			<input id="{name}Name" type="hidden" />
			<input id="{name}Guid" type="hidden" />
		</div>
	{:else if type === 'checkbox'}
		<div class="form-group" style="padding-top: 5px;">
			<label for="{name}"><input type="{type}" {required} class="{classe}" id="{name}" name="{name}" /> {@html title}</label>
		</div>
	{:else}
        <div class="form-group">
            <label for="{name}">{title}</label>
            <input type="{type}" {required} class="form-control {classe}" id="{name}" name="{name}" placeholder="{title}" value="{defaultValue}">
        </div>
    {/if}
{:else}
    {#if type === 'select'}
        <div class="form-group">
            <label style="display: none;" for="{name}">{title}</label>
            <select class="form-control" name="{name}">
                {#each selectValues as v}
                    <option value="{v.value}">{v.title}</option>
                {/each}
            </select>
        </div>
    {:else if type === 'textarea'}
        <div class="form-group">
            <label style="display: none;" for="{name}">{title}</label>
            <textarea {required} class="form-control {classe}" id="{name}" name="{name}" rows={rows}>{defaultValue}</textarea>
        </div>
    {:else}
        <div class="form-group">
            <label style="display: none;" for="{name}">{title}</label>
            <input type="{type}" {required} class="form-control {classe}" id="{name}" name="{name}" placeholder="{title}" value="{defaultValue}">
        </div>
    {/if}
{/if}